// AROMA COMPASS — Vocabolario proprietario (IT + EN)
// Nomi e parole chiave in italiano con equivalente inglese per la modalità EN.

export const OILS = {
  litsea:          { name: "Litsea",            name_en: "Litsea",            keyword: "TRANQUILLITÀ",            keyword_en: "TRANQUILITY" },
  alloro:          { name: "Alloro",            name_en: "Bay Laurel",        keyword: "GOVERNARE",               keyword_en: "GOVERN" },
  cedro_atlantico: { name: "Cedro Atlantico",   name_en: "Atlas Cedar",       keyword: "TRASFERIRE",              keyword_en: "TRANSFER" },
  patchouli:       { name: "Patchouli",         name_en: "Patchouli",         keyword: "BILANCIAMENTO",           keyword_en: "BALANCING" },
  magnolia:        { name: "Magnolia",          name_en: "Magnolia",          keyword: "SIGNIFICATO",             keyword_en: "MEANING" },
  cisto:           { name: "Cisto",             name_en: "Cistus",            keyword: "NUOVO INIZIO",            keyword_en: "NEW BEGINNING" },
  lavanda:         { name: "Lavanda vera",      name_en: "True Lavender",     keyword: "AIUTO",                   keyword_en: "SUPPORT" },
  mandarino:       { name: "Mandarino",         name_en: "Mandarin",          keyword: "ABBRACCIO",               keyword_en: "EMBRACE" },
  vaniglia:        { name: "Vaniglia",          name_en: "Vanilla",           keyword: "SODDISFAZIONE",           keyword_en: "FULFILLMENT" },
  limone:          { name: "Limone",            name_en: "Lemon",             keyword: "ATTIVAZIONE",             keyword_en: "ACTIVATION" },
  abete:           { name: "Abete",             name_en: "Fir",               keyword: "ENERGIA",                 keyword_en: "ENERGY" },
  arancio_dolce:   { name: "Arancio dolce",     name_en: "Sweet Orange",      keyword: "RISVEGLIO",               keyword_en: "AWAKENING" },
  ylang_ylang:     { name: "Ylang Ylang",       name_en: "Ylang Ylang",       keyword: "SERENITÀ",                keyword_en: "SERENITY" },
  basilico:        { name: "Basilico",          name_en: "Basil",             keyword: "DIREZIONE",               keyword_en: "DIRECTION" },
  mirra:           { name: "Mirra",             name_en: "Myrrh",             keyword: "CONDURRE",                keyword_en: "LEAD" },
  lime:            { name: "Lime",              name_en: "Lime",              keyword: "GRATITUDINE",             keyword_en: "GRATITUDE" },
  pompelmo:        { name: "Pompelmo",          name_en: "Grapefruit",        keyword: "SBLOCCARE",               keyword_en: "RELEASE" },
  eucalipto:       { name: "Eucalipto",         name_en: "Eucalyptus",        keyword: "FREDDO",                  keyword_en: "COLD" },
  camomilla:       { name: "Camomilla romana",  name_en: "Roman Chamomile",   keyword: "FORTE CALMA",             keyword_en: "DEEP CALM" },
  geranio:         { name: "Geranio",           name_en: "Geranium",          keyword: "EQUILIBRIO",              keyword_en: "BALANCE" },
  rosmarino:       { name: "Rosmarino",         name_en: "Rosemary",          keyword: "MEMORIA / CONSOLIDAMENTO", keyword_en: "MEMORY / CONSOLIDATION" },
};

// Mapping categorie emozionali → olio primario.
export const CATEGORY_TO_OIL = {
  energia: "abete",
  direzione: "basilico",
  attivazione: "limone",
  risveglio: "arancio_dolce",
  gioia: "arancio_dolce",
  abbondanza: "arancio_dolce",
  sblocco: "pompelmo",
  calma: "litsea",
  forte_calma: "camomilla",
  serenita: "ylang_ylang",
  equilibrio: "patchouli",
  nuovo_inizio: "cisto",
  soddisfazione: "vaniglia",
  gratitudine: "lime",
  aiuto: "lavanda",
  abbraccio: "mandarino",
  chiarezza: "eucalipto",
  significato: "magnolia",
  condurre: "mirra",
  governare: "alloro",
  trasferire: "cedro_atlantico",
  memoria: "rosmarino",
  consolidamento: "rosmarino",
};

export const CATEGORY_LABELS = {
  energia: "Energia",
  direzione: "Direzione",
  attivazione: "Attivazione",
  risveglio: "Risveglio",
  gioia: "Gioia",
  abbondanza: "Abbondanza",
  sblocco: "Sblocco",
  calma: "Calma",
  forte_calma: "Forte calma",
  serenita: "Serenità",
  equilibrio: "Equilibrio",
  nuovo_inizio: "Nuovo inizio",
  soddisfazione: "Soddisfazione",
  gratitudine: "Gratitudine",
  aiuto: "Sostegno",
  abbraccio: "Accoglienza",
  chiarezza: "Chiarezza",
  significato: "Significato",
  condurre: "Condurre",
  governare: "Governare",
  trasferire: "Trasferire",
  memoria: "Memoria",
  consolidamento: "Consolidamento",
};

// Risolve un olio in base alla lingua corrente (name/keyword vs _en).
export function resolveOil(oilObj, lang = "it") {
  if (!oilObj) return oilObj;
  if (lang === "en") {
    return {
      ...oilObj,
      name: oilObj.name_en || oilObj.name,
      keyword: oilObj.keyword_en || oilObj.keyword,
    };
  }
  return { ...oilObj };
}
